import React, { useRef } from 'react';
var VeltNotificationsPanelContentLoadMore = function (props) {
    var isLoadMoreVisible = props.isLoadMoreVisible, notifications = props.notifications, children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-notifications-panel-content-load-more", { ref: ref, "is-load-more-visible": [true, false].includes(isLoadMoreVisible) ? (isLoadMoreVisible ? 'true' : 'false') : undefined, notifications: notifications ? (typeof notifications === 'string' ? notifications : JSON.stringify(notifications)) : undefined }, children));
};
export default VeltNotificationsPanelContentLoadMore;
